module.exports = __webpack_public_path__ + "img/copy.26398714.svg";